import React from 'react'

const ShapesIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M13.4033 24H24V13.4033H13.4033L13.4033 24ZM14.8083 14.8083H22.595V22.595H14.8083V14.8083ZM18.2738 11.4523C21.4312 11.4523 24 8.88356 24 5.72606C24 2.5688 21.4312 0 18.2738 0C15.1163 0 12.5477 2.56875 12.5477 5.72625C12.5477 8.88375 15.1164 11.4523 18.2738 11.4523ZM18.2738 1.40498C20.6565 1.40498 22.595 3.3435 22.595 5.72625C22.595 8.109 20.6565 10.0474 18.2738 10.0474C15.891 10.0474 13.9526 8.10881 13.9526 5.72606C13.9526 3.34331 15.8912 1.40498 18.2738 1.40498ZM0 10.8428H12.3142L6.15713 0L0 10.8428ZM2.4135 9.43781L6.15713 2.84531L9.9007 9.43781H2.4135ZM2.9835 13.6648L0 18.8324L2.9835 24H8.95055L11.9343 18.8324L8.95055 13.6646H2.9835V13.6648ZM8.13942 22.595H3.79467L1.6223 18.8324L3.79467 15.0696H8.13942L10.3117 18.8324L8.13942 22.595Z"
            fill={color}
        />
    </svg>
)

export default ShapesIcon
